import React, { useState } from 'react';
import RemoteAutoComplete from 'components/shared/RemoteAutoComplete';
import request from 'utils/request_ajax';
import { TYPES, routes } from 'constants/config';
import { useFetch } from 'hooks';
import { Icon, Spinner } from 'ui';
import InfoTooltip from 'components/shared/InfoTooltip';

const Tag = ({ name }) => name;

const Taggings = ({ lessonId, archived }) => {
  const [waiting, setWaiting] = useState(false);
  const {
    data: existingTaggings,
    loading,
    initialLoading,
    runRequest,
  } = useFetch(routes.ALL_TAGGINGS(TYPES.LESSON, lessonId));
  if (initialLoading)
    return (
      <div className="d-f ai-c jc-c">
        <Spinner />
      </div>
    );
  const existingTagIds = existingTaggings.map(tagging => tagging.tag.id);
  const createTagging = tag => {
    setWaiting(true);
    const taggingData = {
      taggableId: lessonId,
      taggableType: TYPES.LESSON,
      tagId: tag.id,
    };
    request.postJSON(routes.TAGGINGS, { tagging: taggingData }).then(() => {
      runRequest();
      setWaiting(false);
    });
  };
  const removeTagging = taggingId => {
    setWaiting(true);
    request.delete(routes.TAGGING(taggingId)).then(() => {
      runRequest();
      setWaiting(false);
    });
  };
  const filterSuggestions = tags =>
    tags.filter(tag => !existingTagIds.includes(tag.id));
  return (
    <div className="Module SidebarModule Autocomplete ui-front">
      <h3 className="Module-heading SectionHeading">
        {archived ? (
          <>
            {t('tags.title')}
            <InfoTooltip
              tooltip={t('archive.uneditable')}
              className="tooltip-fixedWidth Module-headingIcon"
            />
          </>
        ) : (
          <>
            {t('tags.add')}
            <InfoTooltip
              tooltip={t('tags.more_info')}
              className="tooltip-fixedWidth Module-headingIcon"
            />
          </>
        )}
      </h3>
      {!archived && (
        <RemoteAutoComplete
          className="SidebarModule-input new_tagging"
          queryParam="q"
          filterSuggestions={filterSuggestions}
          getSuggestionValue={suggestion => suggestion.name}
          mapResponseToSuggestions={response => response.tags}
          onSuggestionSelected={createTagging}
          shouldRenderSuggestions={() => true}
          placeholder={t('tags.placeholder')}
          renderSuggestion={Tag}
          url={routes.TAGS}
        />
      )}
      <ul className="tag_list">
        {waiting ||
          (loading && (
            <div className="d-f ai-c jc-c mt-8">
              <Spinner />
            </div>
          ))}
        {existingTaggings.map(tagging => (
          <li
            className="quicklist-item"
            id={`tagging_${tagging.id}`}
            key={tagging.id}
          >
            {tagging.tag.name}{' '}
            {!archived && (
              <button
                type="button"
                onClick={() => removeTagging(tagging.id)}
                className="quicklist-remove u-resetBtn"
              >
                <Icon name="remove" />
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default props => <Taggings {...props} />;
